const defaultLocale = 'en-US';
import _ from 'lodash';

interface FormatMoneyOptions extends Intl.NumberFormatOptions {
  locale?: string;
}

export const roudingDownNumber = (value: number, digits: number): number => {
  return _.floor(value, digits);
};

export default number => {
  if (!number) {
    return '-';
  }

  const formatedNumber = Math.abs(number)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  if (parseFloat(number) < 0) {
    return `-${formatedNumber}`;
  }

  return `${formatedNumber}`;
};

export const formatNumber = (
  value: number,
  options: Intl.NumberFormatOptions = {}
) => {
  return new Intl.NumberFormat(defaultLocale, {
    ...options,
  }).format(value);
};

export const formatCurrency = (value: any, options?: FormatMoneyOptions) => {
  if (value === null) {
    return '-';
  }

  const numericValue = Number(value);

  if (isNaN(numericValue)) {
    return '';
  }

  const {
    locale = defaultLocale,
    currency = 'VND',
    currencyDisplay = 'symbol',
    ...others // other options
  } = options || {};

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay,
    ...others,
  }).format(roudingDownNumber(numericValue, 0));
};

export const formatUnitQuantity = (
  value: any,
  options?: FormatMoneyOptions
) => {
  if (value === null) {
    return '-';
  }

  const numericValue = Number(value);

  if (isNaN(numericValue)) {
    return '';
  }

  return formatNumber(roudingDownNumber(numericValue, 2), {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...options,
  });
};

export const formatNumberOrDash = value => {
  if (value === null || value === undefined) {
    return '-';
  }
  return formatNumber(value);
};
